import React from 'react';
import ComingSoon from '../components/ComingSoon';
import './PageStyles.scss';

const Documents: React.FC = () => {
  return (
    <div className="hr-portal-page">
      <div className="hr-portal-page-header">
        <h2>Documents</h2>
        <p className="page-description">Manage employee documents and document library</p>
      </div>
      <div className="hr-portal-page-content">
        <ComingSoon title="Coming Soon" />
      </div>
    </div>
  );
};

export default Documents;
